import KendoCalendar from '../KendoCalendar'
import KendoDateInput from '../KendoDateInput'
import KendoDatePicker from '../KendoDatePicker'
import KendoDateTimePicker from '../KendoDateTimePicker'
import KendoTimePicker from '../KendoTimePicker'
import KendoMultiViewCalendar from '../KendoMultiViewCalendar'
import KendoDateRangePicker from '../KendoDateRangePicker'

let KendoDateinputsInstaller = class {
    static install(Vue) {
        Vue.component(KendoCalendar.name, KendoCalendar)
        Vue.component(KendoDateInput.name, KendoDateInput)
        Vue.component(KendoDatePicker.name, KendoDatePicker)
        Vue.component(KendoDateTimePicker.name, KendoDateTimePicker)
        Vue.component(KendoTimePicker.name, KendoTimePicker)
        Vue.component(KendoMultiViewCalendar.name, KendoMultiViewCalendar)
        Vue.component(KendoDateRangePicker.name, KendoDateRangePicker)
    }
}

export default KendoDateinputsInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoDateinputsInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/kendo-dateinputs-installer/index.js